import React, { useState, useContext } from 'react';
import {
  SafeAreaView,
  StyleSheet,
  View,
  Text,
  TextInput,
  Button,
  Image,
  Alert,
  TouchableOpacity,
  Modal,
  ScrollView,
  ImageBackground,
} from 'react-native';
import { ProductsContext } from '../Contexts/ContextProdutos';
import { EstoqueContext } from '../Contexts/ContextEstoque';
import firebase from 'firebase';

var app = firebase.app();

var db = app.database();


const ButtonChangePage = ({ PaginaCarrinho, PaginaPerfil, PaginaSobre}) => {
  return (
    <View style={Style.ButtonsMenu}>
      <View>
      <TouchableOpacity style={Style.ButtonMenu} onPress={PaginaCarrinho}>
        <Image
          style={Style.IconMenu}
          source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/804330271288852490/IconeCarrinho.PNG'}}
        />
      </TouchableOpacity>
      </View>

      <View>
      <TouchableOpacity style={Style.ButtonMenu} onPress={PaginaPerfil}>
        <Image
          style={Style.IconMenu}
          source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/804330284513492992/IconePerfil.PNG'}}
        />
      </TouchableOpacity>
      </View>
      
      <View>
      <TouchableOpacity style={Style.ButtonMenu} onPress={PaginaSobre}>
        <Image
          style={Style.IconMenu}
          source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/811755835994275860/aboutIcon.PNG'}}
        />
      </TouchableOpacity>

      </View>
    </View>
  );
};


{/*------------------------------------------------------------------------------------------------------------*/}


const SearchBar = ({
  searchString,
  setSearchString,
}) => {
  return (
    <View style={Style.SearchBarConfig}>
      <TextInput
        value={searchString}
        onChangeText={(value) => setSearchString(value)}
        placeholder={'Pesquisar'}
        style={Style.inputStyle}
      />
    </View>
  );
};


{/*------------------------------------------------------------------------------------------------------------*/}


const ProductsOrganized = (props) => {
  const { estado, actions } = useContext(ProductsContext);
  if(props == []){
    return
  } else{
  const handlePush = (newProduct) => {
    console.log(newProduct)
    actions.setProducts(estado.cart.products.push(newProduct));
    console.log(estado.cart.products)
    alert(`${newProduct.nome} adicionado ao carrinho`);
  };
  console.log(props)
  return (
    <View>
      <ImageBackground style={Style.imagem} source={props.imagem}>
        <TouchableOpacity
          style={Style.ButtonCart}
          onPress={() =>
            handlePush({
              nome: props.nome,
              preço: props.preço, 
              valor: props.valor,
              imagem: props.imagem,
            })
            }>
            <Image
              style={Style.IconCart}
              source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/804330267632336896/IconeAdicionarCarrinho.PNG'}}
            />
        </TouchableOpacity>

      </ImageBackground>
      <View style={Style.Products}>
        <Text style={Style.nome}> {props.nome} </Text>

        <Text style={Style.preço}> {props.preço} </Text>

        
      </View>
    </View>
  );
}
};


{/*------------------------------------------------------------------------------------------------------------*/}


const TelaInicio = (props) => {
  console.log("TelaInicio")
  const [pesquisa, setPesquisa] = useState('');
  const { state, actions } = useContext(EstoqueContext);
  var ArrayComidas = state.itens
  console.log(Object.values(state.itensf))
  var ArrayComidasFiltrado
  if(Object.values(state.itensf) == "zap" || Object.values(state.itensf) == ArrayComidas){
    ArrayComidasFiltrado = ArrayComidas
  }else{
    ArrayComidasFiltrado = Object.values(state.itensf)
  }
  console.log("produtos: ", ArrayComidasFiltrado)
  console.log("values: ", Object.values(ArrayComidasFiltrado))
  var ArrayComidas1
  var ArrayComidas2
  ArrayComidas1 = Object.values(ArrayComidasFiltrado).splice(parseInt(Object.values(ArrayComidasFiltrado).length/2))
  ArrayComidas2 = Object.values(ArrayComidasFiltrado).splice(0, parseInt(Object.values(ArrayComidasFiltrado).length/2))

  // Função com a condição para a pesquisa
  function Search(pesquisa) {
    console.log('frito')
      setPesquisa(pesquisa);
    console.log(pesquisa)
    function check(produto) {
      console.log(produto)
      console.log("produto atual: ", produto.nome)
      return produto.nome.toLowerCase().includes(pesquisa.toLowerCase())
    }

    if (pesquisa === '') {
      console.log('vazio')
      ArrayComidasFiltrado = ArrayComidas
      // ArrayBebidasFiltrado = ArrayBebidas;
    } else {
      console.log('algo')
      console.log(ArrayComidas)
      console.log(ArrayComidasFiltrado)
      // ArrayBebidasFiltrado = ArrayBebidas.filter((produto) =>
      //   produto.nome.toLowerCase().includes(pesquisa.toLowerCase())
      // );
      ArrayComidasFiltrado = Object.values(ArrayComidas).filter(check);
    }
    state.itensf = ArrayComidasFiltrado
    console.log(ArrayComidasFiltrado)
  }

  function PaginaCarrinho() {
    props.navigation.navigate('CARRINHO');
  }

  function PaginaPerfil() {
    props.navigation.navigate('PERFIL');
  }

  function PaginaSobre() {
    props.navigation.navigate('SOBRE');
  }
  return (
    <View style={{
      backgroundColor: 'rgba(179, 179, 179, 255)',
    }}>

      <View style={Style.Cabeçalho}>

      <ButtonChangePage
          PaginaCarrinho={PaginaCarrinho}
          PaginaPerfil={PaginaPerfil}
          PaginaSobre={PaginaSobre}
          
        />
        <View style={{
          flexDirection: 'row-reverse',
          marginStart: 15,
        }}>
          <Image
            style={Style.CantinaSantaClara}
            source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/809404531241779240/logoCantina.png'}}
          />
        </View>
      </View>
      
        <SearchBar
          searchString={pesquisa}
          setSearchString={Search}
        />

      <ScrollView style={Style.scrollView}>
        <View style={Style.ProductsMenu}>
          {/* COMIDAS */}

          <View style={Style.Top}>
            <View style={{
            flexDirection: 'column',
          }}>
            {ArrayComidas1.map((comidas) => (
              <ProductsOrganized
                nome={comidas.nome}
                valor={comidas.valor}
                preço={comidas.preço}
                imagem={{uri: comidas.imagem}}
              />
            ))}
          </View>

          <View style={{
            flexDirection: 'column',
          }}>
            {ArrayComidas2.map((comidas) => (
              <ProductsOrganized
                nome={comidas.nome}
                valor={comidas.valor}
                preço={comidas.preço}
                imagem={{uri: comidas.imagem}}
              />
            ))}
          </View>


         </View>
        </View>
      </ScrollView>
      <Text style={Style.ImagesText}> • Imagens meramente ilustrativas </Text>
    </View>
  );
};

const Style = StyleSheet.create({
  Top: {
    justifyContent: 'space-between',
    flexDirection: 'row',
    
    width: '90%',
    height: '100%',

  },

  ImagesText: {
    textAlign: 'center',

    fontFamily: 'System',
    fontSize: 13,

    marginBottom: 10,

    color: 'rgba(255, 255, 255, 255)',
  },

  ButtonsMenu: {
    flexDirection: 'row',
    justifyContent: 'space-around',

    width: '100%',
    height: 80,

    marginTop: -10,
  },

  CantinaSantaClara: {
    
    width: 150,
    height: 85,

    

  },

  Cabeçalho: {
    flexDirection: 'column-reverse',
    width: '100%',
    height: 170,

    backgroundColor: 'rgba(0, 58, 109, 255)',
  },

  categoria: {
    fontFamily: 'System',
    fontSize: 20,
    color: 'rgba(255, 255, 255, 255)',
    marginTop: 10,
  },

  nome: {
    fontFamily: 'System',
    fontSize: 12,
    color: 'rgba(255, 255, 255, 255)',
    marginTop: 1,
  },

  preço: {
    fontFamily: 'System',
    fontSize: 12,
    color: 'rgba(255, 255, 255, 255)',
    marginTop: 1,
  },

  Products: {
    alignItems: 'flex-start',

    paddingStart: 5,
    paddingTop: 5,

    width: 150,
    height: 90,

    borderRadius: 20,
  },

  scrollView: {
    marginBottom: 250,
    marginTop: 20,
  },

  IconMenu: {
    height: 20,
    width: 20,
  },

  IconOpenMenu: {
    justifyContent: 'center',
    height: 25,
    width: 25,
  },

  IconCart: {
    height: 20,
    width: 20,
  },

  ButtonMenu: {
    
    flexDirection: 'row',
        

    backgroundColor: 'rgba(255, 255, 255, 255)',

    borderRadius: 50,

    padding: 7,

    marginBottom: 30,
    marginTop: 30,

    shadowColor: '#303838',
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 10,
    shadowOpacity: 0.35,
  },

  ButtonOpenMenu: {
    justifyContent: 'center',

    backgroundColor: 'rgba(255, 255, 255, 255)',

    borderRadius: 50,

    height: 35,
    width: 35,

    marginBottom: 30,
    marginTop: 30,
    
    shadowColor: '#303838',
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 10,
    shadowOpacity: 0.35,
  },

  ButtonCart: {
    backgroundColor: 'rgba(255, 255, 255, 255)',
    borderRadius: 20,

    padding: 5,

    marginBottom: 20,
    marginTop: 50,
    marginHorizontal: 110,

    shadowColor: '#303838',
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 10,
    shadowOpacity: 0.35,
  },

  categoriasMenu: {
    flexDirection: 'row',
    justifyContent: 'space-around',

    marginLeft: 5,
    marginRight: 5,

    marginTop: 15,
  },

  ProductsMenu: {
    flexDirection: 'row',
    alignContent: 'space-between',
    alignSelf: 'center',

    marginLeft: 10,
    marginRight: 10,
  },

  imagem: {
    alignItems: 'flex-start',

    paddingStart: 5,
    paddingTop: 5,

    width: 150,
    height: 90,

    borderRadius: 20,
  },

  SearchBarConfig: {
    flexDirection: 'row',

    width: '95%',
    height: 50,

    padding: 20,

    marginStart: '2.5%',
    marginTop: 25,

    backgroundColor: '#FFFFFF',

    borderRadius: 50,

    borderWidth: 1,
    borderColor: 'rgba(0, 58, 109, 255)',
  },

  inputStyle: {
    width: '85%',
    height: 47,

    padding: 10,

    marginVertical: -20,
    marginStart: '-5%',

    backgroundColor: '#FFFFFF',

    borderRadius: 50,
  },

  botãoModal: {
    backgroundColor: 'rgba(255, 255, 255, 255)',
    borderRadius: 50,
    padding: 10,
    marginTop: '-4%',
    marginStart: '10%',
    shadowColor: '#303838',
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 10,
    shadowOpacity: 0.35,
  },

  imagemFechar: {
    height: 15,
    width: 15,
  },
  
});

export default TelaInicio;
